import * as React from "react";
import { useEffect, useState } from "react";
import { Box, Button, Typography, Grid2, LinearProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import SignUpBg from "../../../../Assets/Images/Signup_web.png";
import {useSelector, useDispatch } from 'react-redux';
import { retakeFaceMatchApi, retakeLiveness, setDummyUser, retakeConfirm } from "../../../../Redux/usersSlice";
import icon from "../../../../Assets/Images/icon.svg"
import success from "../../../../Assets/Images/bvsuccess.svg"
import CaptureStyles1 from "../capturePhotoStyle.module.css";
import SignatureStyles from "../../Signature/Signature.module.css"
import Webcam from "react-webcam";
import { publicIpv4 } from 'public-ip';
import CryptoJS from "crypto-js";
const webcamRef = React.createRef(null);

export default function CaptureRetakeSelfieMobile() {

    const dispatch = useDispatch();
    // const {panData,faceMatch} = useSelector( state => state.user);
    // console.log("pan",panData?.facematch,faceMatch)
   
    // dispatch(setDummyUser())

    const [capturedImage, setCapturedImage] = useState(null);
    const [matchScore, setMatchScore] = useState(0)
    const [livelinessScore, setLivelinessScore] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [passed, setPassed] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)

    const [backend, setBackend] = useState(false);
    const [facematch, setFacematch] = useState(false);
    const location = useLocation();

    const [user, setUser] = useState({
        mobile: "",
        email: "",
        user_id: ""
    })

    const handleReset = () => {
        setIsCompleted(true)
        setCapturedImage(null)
        setPassed(false)
        setLivelinessScore(0)
        setMatchScore(0)
    }

    const params = new URLSearchParams(window.location.search)
    
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "retake_selfie_qrpage_viewed",
            page_path: window.location.pathname
        });
        if (params.get("data")) {
            const bytes = CryptoJS.AES.decrypt(params.get("data")?.split(" ")?.join("+"), "96358214256984120");
            const decryptedText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(decryptedText, "decoded data");
            setUser({ ...decryptedText })
        }
    }, [])


    
    useEffect(()=>{
        if(user?.mobile){
            (async ()=>{
                try{
                    const signatureStatus = await dispatch(retakeConfirm({mobile : user?.mobile,email: user?.email,type : "selfie"})).unwrap();
                    console.log("11", signatureStatus?.data)
                    if(signatureStatus?.data?.data?.success){
                    console.log("12", signatureStatus?.data)
                      setIsCompleted(true)
                    }
                }catch(e){
                    console.log(e)
                }
        
            })()
        }
    },[user])

 

const handleCapture = async () => {
    
    
        setError(false)
        setErrorMessage("")
        if (capturedImage) {
            setCapturedImage(false)
            setIsLoading(false)
            return
        }
        setIsLoading(true)
        setLivelinessScore(0)
        setMatchScore(0)
        setPassed(false)

        const { email, mobile } = user
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "retake_selfie_qr_capture",
            page_path: window.location.pathname
        });
        const imageSrc = webcamRef.current.getScreenshot({ width: 972, height: 1296, dpi: 96 });
        if (imageSrc) {
            setCapturedImage(imageSrc);

            try {
                const faceVerify = await dispatch(retakeFaceMatchApi({ mobile, email, selfieImage: imageSrc,device:"QR" })).unwrap()
                const data = faceVerify?.data?.data

                if (data?.success == true) {
                    setMatchScore(data?.similarity)
                    const ip = await publicIpv4()
                    const livenessVerify = await dispatch(retakeLiveness({ mobile, email, selfieImage: imageSrc, ip: ip, device: "QR" })).unwrap()
                    const livenessResult = livenessVerify?.data?.data

                    if (livenessResult?.success) {
                        setLivelinessScore(livenessResult?.score)
                        setPassed(true)
                    } else {
                        setError(true)
                        setErrorMessage(livenessResult?.message)
                    }
                    setIsLoading(false)
                } else {
                    setError(true)
                    setErrorMessage(data.message)
                }

                setIsLoading(false)
            } catch (error) {
                setError(true)
                setIsLoading(false)
                setErrorMessage(error?.data?.data?.message)
            }

        }
    }

console.log("livenessResultOut",livelinessScore)
    return (
        <Box sx={{
            display: "flex",
            minHeight: "100vh !important",
            backgroundImage: `url(${SignUpBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}>
            {isCompleted &&
                <Box className={SignatureStyles.content_wrapper}>
                    <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px" width="100%">
                        <img src={success} alt="successLogo" />
                        <Typography className={SignatureStyles.title} sx={{ padding: "0px 30px" }}>Your selfie has been captured successfully</Typography>
                        {/* <Button sx={{ marginTop: "30px" }} onClick={() => {
                        setIsCompleted(false)
                        setCapturedImage(null)
                        setPassed(false)
                    }} className={SignatureStyles.skip_button}>
                        Edit
                    </Button> */}
                    </Grid2>
                </Box>
            }

            {/* Your content area */}
            {!isCompleted && <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        color: "#481B9D",
                        fontSize: "48px",
                        fontFamily: "Inter900",
                        paddingTop: "70px",
                        marginBottom: "10px",
                        padding: "20px",
                        textAlign: "center",
                        "@media screen and (max-width : 600px)": {
                            fontSize: "30px !important",
                        }
                    }}
                    className={CaptureStyles1.heading}
                >
                    Stay still and Capture now
                </Typography>
                <Grid2>
                    <div
                        style={{
                            width: "267px",
                            height: "273px",
                            border: "8px solid #1CF400",
                            borderRadius: "50%",
                            overflow: "hidden",
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {capturedImage ? (
                            <img
                                src={capturedImage}
                                alt="Captured"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        ) : (
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                screenshotQuality={1}
                                mirrored={true}
                                videoConstraints={{
                                    facingMode: "user", // front camera for selfie
                                }}
                                style={{
                                    objectFit: "cover",
                                    width: "100%",
                                    height: "100%",
                                }}
                            />
                        )}
                    </div>
                </Grid2>
                {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", width: "300px", marginTop: "20px" }}>
                    {isLoading ? <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box> :
                        <>
                            {/* <Typography>Face Match - {matchScore?.toFixed(2)}%</Typography> */}
                             <Typography>
                                Face Match - {matchScore > 0 ? `${matchScore.toFixed(2)}%` : "NA"} {/* if NA , Face match is skiped */}
                                </Typography>
                            <Typography sx={{ marginLeft:"5px"}} >liveness - {livelinessScore?.toFixed(2)}%</Typography></>}
                </Grid2>}
                {/* {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "center", alignItems: "center", width: "300px", marginTop: "20px" }}>
                    {isLoading ? <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box> :
                        <Typography>Liveness - {livelinessScore?.toFixed(2)}%</Typography>}
                </Grid2>} */}

                {error && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "red", textAlign: "center" }}>{errorMessage}</Typography>
                </Grid2>}
                {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "green" }}>Face Match Success</Typography>
                </Grid2>}
                {/* {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "green" }}>Liveness Check Passed</Typography>
                </Grid2>} */}
                <Grid2 className={CaptureStyles1.but_card}>
                    <Grid2>
                        {!passed && <Button
                            disabled={isLoading}
                            className={CaptureStyles1.con_button}
                            onClick={handleCapture}
                        >
                            {capturedImage ? "Capturing" : "Capture Photo"}
                        </Button>}
                        {passed && <Button
                            disabled={isLoading}
                            className={CaptureStyles1.con_button}
                            onClick={handleReset}
                        >
                            continue
                        </Button>}
                        {/* {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                                          <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" , fontSize : "16px" }} onClick={() =>{
                                            setIsCompleted(false)
                                            setCapturedImage(null)
                                            setPassed(false)
                                          } }>Take Selfie again</span>
                                        </Typography>} */}
                    </Grid2>

                </Grid2>
                <Typography className={CaptureStyles1.footerText}>
                    Please allow LOCATION and CAMERA permissions when requested. You
                    need to do this only ONCE as per SEBI regulations, to open a Demat
                    account.
                </Typography>

                <Box className={CaptureStyles1.card}>
                    <img
                        src={icon} // Replace with your image URL
                        alt="Checkmark"
                        className={CaptureStyles1.icon}
                    />
                    <Typography className={CaptureStyles1.txt}>
                        Your account details are safe & secure with us.
                    </Typography>
                </Box>
            </Box>}
        </Box>
    );
}


